import React from "react";
import cx from "classnames";
import { CrumbContainer, CrumbStepContainer } from "./crumb.styles";
import { CrumbBar } from "./crumbBar";
import { NumberBall } from "./numberBall";
import { CheckCircle } from "@components/icons";
import { IndicatorBar } from '../index';

export const Crumb = ({crumbNumber, currentCrumb, totalCrumbs, step, stepMobile, statusThemeColor, showIndicatorStatus, daysUntilExpiry, declineIsActive}) => {
  const isActive = crumbNumber === currentCrumb;
  const isComplete = crumbNumber < currentCrumb
  const crumbBarIsActive = isActive || isComplete;

  return (
    <CrumbContainer className={cx({'is-active': isActive, 'is-complete': isComplete})}>
      <CrumbStepContainer>
        <CrumbBar isActive={crumbBarIsActive} isHidden={crumbNumber === 0} />
        <NumberBall className={cx({'is-active': isActive, 'is-complete': isComplete})}>
          <CheckCircle className="check" />
        </NumberBall>
        <div className={cx({'is-not-active' : !isActive}, 'ring')}/>
        <CrumbBar isActive={crumbBarIsActive} isHidden={crumbNumber === totalCrumbs - 1} />
      </CrumbStepContainer>
      <span className="crumb-title crumb-title-desktop">{step}</span>
      <span className="crumb-title crumb-title-mobile">{stepMobile || step}</span>
      <IndicatorBar declineIsActive={declineIsActive} daysUntilExpiry={daysUntilExpiry} showIndicatorStatus={showIndicatorStatus} isActive={isActive} backgroundColor={statusThemeColor}/>
    </CrumbContainer>
  )
};